var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "r-items-holder-page" },
    [
      _c(
        "v-tabs",
        {
          attrs: { "background-color": "blue-grey lighten-5" },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab", { key: "item_page" }, [_vm._v("Items")]),
          _c("v-tab", { key: "item_kind" }, [_vm._v("Kind")]),
          _c("v-tab", { key: "item_group" }, [_vm._v("Group")]),
          _c("v-tab", { key: "item_shop" }, [_vm._v("Shop")]),
          _c("v-tab", { key: "item_offer" }, [_vm._v("Offer")]),
          _c("v-tab", { key: "item_order" }, [_vm._v("Order")]),
          _c("v-tab", { key: "item_addon" }, [_vm._v("Addon")]),
          _c("v-tab", { key: "item_recipe" }, [_vm._v("Recipe")]),
          _c("v-tab", { key: "item_cluster" }, [_vm._v("Cluster")]),
          _c("v-tab", { key: "item_social" }, [_vm._v("Social")]),
        ],
        1
      ),
      _c(
        "v-tabs-items",
        {
          staticClass: "mt-4",
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tab-item", { key: "item_page" }, [_c("r-item-page")], 1),
          _c("v-tab-item", { key: "item_kind" }, [_c("r-item-kind-page")], 1),
          _c("v-tab-item", { key: "item_group" }, [_c("r-item-group-page")], 1),
          _c("v-tab-item", { key: "item_shop" }, [_c("r-item-shop-page")], 1),
          _c("v-tab-item", { key: "item_offer" }, [_c("r-item-offer-page")], 1),
          _c("v-tab-item", { key: "item_order" }, [_c("r-item-order-page")], 1),
          _c("v-tab-item", { key: "item_addon" }, [_c("r-item-addon-page")], 1),
          _c(
            "v-tab-item",
            { key: "item_recipe" },
            [_c("r-item-recipe-page")],
            1
          ),
          _c(
            "v-tab-item",
            { key: "item_cluster" },
            [_c("r-item-cluster-page")],
            1
          ),
          _c(
            "v-tab-item",
            { key: "item_social" },
            [_c("r-item-social-page")],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }